export default {
      id: "copy-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#copy",
      toString: function () {
        return this.url;
      }
    }